import { getAdminUiUrlByPlatform } from "utils/adminUi";
import { getGAEvent } from "utils/analyticsEvents";
import { getAgent, getPlatform } from "utils/token/token";
const host = window.location.host
const unSupportedHosts = ['-hmg']
const APP = 'manager_whatsapp_connect'
export const enabledGA4 = !unSupportedHosts.some((item) => host.includes(item))
let isReady = false

const TRACKING_ID  = process.env.REACT_APP_GANALYTICS_ID
const PARENT_URL = getAdminUiUrlByPlatform(getPlatform()) || 'https://localhost:3030'

export function initGAnalytics() {
  
  if (!TRACKING_ID) {
    console.warn('GA: Tracking ID is not defined.')
    return
  }

  const {id, tenantId, agentName, userName, siteName, siteId} = getAgent()

  if(Object.values({id, tenantId, agentName, userName, siteName, siteId}).some(item => item === null || item === undefined)) {
    console.warn(`GA: The user data is not defined`);
    return
  } 
  
  if(!isReady){
    try {
      window.parent.postMessage({
        action: '[AnalyticsActions]InitializeGA4',
        data: {
          app: APP,
          measurementId: TRACKING_ID,
          userProperties: {
            agentId: id,
            agentName,
            userName,
            siteName,
            siteId,
            tenantId,
          }
        },
      }, PARENT_URL)
      isReady = true
    } catch (error) {
      console.error('ERROR ON INITIALIZE ANALYTICS', error)
    }
  }
}

/**
 * This function register event based on `GA_EVENTS`\
 * The label is truncated automatically if legth is great than 60.
 * 
 * @param {object} props
 * @param {string} props.eventType 
 * @param {string} props.label
 * @param {unknown} [props.value=null]
 * @param {string} [props.trackerName=null]
 */
export const registerCustomEvent = ({eventType, label, trackerName, value}) => {
  if (enabledGA4 && isReady) {    
    try {
      const receivedEvent = getGAEvent({eventType, label})
      if(receivedEvent) {
        window.parent.postMessage({
          action: '[AnalyticsActions]RegisterEventGA4',
          data: {
            app: APP,
            eventAction: `hi_${receivedEvent.action}`,
            eventProperties: receivedEvent.properties
          },
        }, PARENT_URL)
      }
    } catch (error) {
      console.error('ERROR ON REGISTER CUSTOM EVENT', error)
    }
  } else {
    console.warn(`no register '${eventType}' event`)
  }
}

/**
 * This function receive the pathname and page title
 * 
 * @param {object} props
 * @param {string} props.pathname
 * @param {string} props.title
 */
export function registerPageView({pathname, title}) {
  if (enabledGA4 && isReady){
    try {
      window.parent.postMessage({
        action: '[AnalyticsActions]PageViewGA4',
        data: {
          app: APP,
          measurementId: TRACKING_ID,
          location: window.location.origin + pathname,
          pathname,
          title: title || 'Static Whatsapp Connect',
          params: null,
        },
      }, PARENT_URL)
    } catch (error) {
      console.error('ERROR ON REGISTER PAGEVIEW EVENT', error)
    }
  } else {
    console.warn(`no dispatch pageview event to ${pathname}`)
  }
}
